import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import type { CreateUserHandler } from '../types';
import buildCreateUserRows from './buildCreateUserRows.helper';
import { UtilButton } from 'UI';
import { useHistory } from 'react-router-dom';

const { Box, Button, Title, Table, TextField } = vp;

type CreateUserProps = {
  handlers: CreateUserHandler;
  defaultValues: vp.CreateUserRequest;
};
type FC = FunctionComponent<CreateUserProps>;

const CreateUser: FC = (props: CreateUserProps) => {
  const { handlers, defaultValues } = props;
  const createUserRow = buildCreateUserRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Users.CreateUser.CreateUserForm' });
  const { t: tUsersList } = useTranslation('translations', { keyPrefix: 'Users.UsersList' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const history = useHistory();
  return (
    <Formik
      initialValues={defaultValues}
      onSubmit={handlers.onChangeCreateUser}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ touched, errors, handleChange, handleBlur, handleSubmit }) => {
        const createUserTable: vp.TableProps = {
          name: 'create-user-fields',
          variant: 'pair',
          columns: {
            Field: { header: t('labelsHeader') || '' },
            Input: { header: t('form.fieldsHeader') || '' },
          },
          rows: createUserRow.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="standard"
                onBlur={handleBlur}
                onChange={handleChange}
                error={errors[id] && touched[id] ? errors[id] : null}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="md" gapSize="16px">
              <UtilButton
                iconLeft="chevron_left"
                size="large"
                onClick={() => {
                  if (history.length > 1) {
                    history.goBack();
                  } else {
                    history.replace('/users');
                  }
                }}
              >
                {history.length > 1 ? tGlobal('Buttons.back') : tUsersList('title')}
              </UtilButton>
              <Title title={t('title')} />
            </Box>
            <Table {...createUserTable} />
            <Box mt="md" jc="fe">
              <Button id="CreateLead-submit" type="submit" label={t('saveButton')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
  function createdValidationSchema() {
    return Yup.object().shape({
      EmailAddress: Yup.string().required(t('validation.emailRequired') || ''),
    });
  }
};

export default CreateUser;
